module.exports = __webpack_public_path__ + "static/media/track-logo-white .6fb25b14.png";